import Vue from 'vue';
import supplierTransformer from './../../transformers/supplier';
import store from '../../store';

const success = ({ data }, resolve) => {
  const supplier = supplierTransformer.fetch(data);
  resolve(supplier);
  store.dispatch('fetchCurrentSupplier', supplier);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/suppliers/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/supplier/show.js